import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact, useIonViewWillEnter } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Home from './pages/Home';
import ViewMessage from './pages/ViewMessage';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import { useEffect, useState } from 'react';
import { createStore } from './data/persistent/IonicStore';
import Login from './pages/Login';
import PasswordChange from './pages/PasswordChange';
import Profile from './pages/Profile';
import { profile } from 'console';
import ShowInfo from './pages/ShowInfo';

setupIonicReact();

const App: React.FC = () => {
  const [loginInfo, setLoginInfo] = useState<any|null>(null);
  const [home] = useState<string>("");
  useIonViewWillEnter(()=>{
    const getLoginInfo  = async ()=>{
        let localStore =  await createStore();
        let info = await localStore.get("login_info");
        console.log(info);
        if(info !== null){
          return JSON.parse(info);
        }
        return info;
    }  
    let info = getLoginInfo();
    setLoginInfo(info);
  },[]);
  
  return (
    <IonApp>
      <IonReactRouter>
          <IonRouterOutlet>
            <Route path="/profile" exact>
              <Profile />
            </Route>
            <Route path="/passwordchange" exact>
              <PasswordChange />
            </Route>
            <Route path="/showinfo" exact>
              <ShowInfo />
            </Route>
            <Route path="/" exact={true}>
                <Redirect to={loginInfo === null?"/login":"/profile"} />
              </Route>
              <Route path="/login">
                <Login />
              </Route>
              <Route path="/passwordchange">
                <PasswordChange />
              </Route>
              <Route render={() => <Redirect to="/" />} />
          </IonRouterOutlet>
        
      </IonReactRouter>
    </IonApp>
  );
  
  
}

export default App;
